import { useState, useEffect } from 'react';
import api from '../../api';
import { useAuth } from '../../context/AuthContext';
import { downloadExcel } from '../../utils/excelExport';

function CredentialForm({ sources, providers, onSaved }) {
  const [sourceId, setSourceId] = useState('');
  const [provider, setProvider] = useState('tochka');
  const [label, setLabel] = useState('');
  const [token, setToken] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setResult(null);
    if (!token.trim()) { setError('Вставьте токен'); return; }
    setSaving(true);
    try {
      const { data } = await api.post('/finance/bank/credentials', { source_id: sourceId || null, provider, label: label || null, token: token.trim() });
      setResult(data);
      setToken(''); setLabel('');
      onSaved();
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка сохранения');
    } finally { setSaving(false); }
  };

  return (
    <div className="card mb-2">
      <form onSubmit={submit}>
        <div className="form-row">
          <div className="form-group">
            <label>Юрлицо / компания</label>
            <select value={sourceId} onChange={e => setSourceId(e.target.value)}>
              <option value="">Не привязано</option>
              {sources.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>Банк</label>
            <select value={provider} onChange={e => setProvider(e.target.value)}>
              {providers.map(p => <option key={p.key} value={p.key} disabled={!p.available}>{p.label}{!p.available ? ' (скоро)' : ''}</option>)}
            </select>
          </div>
        </div>
        <div className="form-group">
          <label>Метка (необязательно, для себя)</label>
          <input value={label} onChange={e => setLabel(e.target.value)} placeholder="например, основной токен" />
        </div>
        <div className="form-group">
          <label>Токен API банка</label>
          <textarea rows={2} value={token} onChange={e => setToken(e.target.value)} placeholder="Вставьте токен из личного кабинета банка" />
        </div>
        {error && <div className="error-msg">{error}</div>}
        <button type="submit" className="btn-primary btn-sm" disabled={saving}>{saving ? 'Проверяем токен...' : 'Сохранить и найти счета'}</button>
      </form>

      {result && (
        <div className="mt-2">
          {result.discoverError && <div className="error-msg">Токен сохранён, но не удалось получить список счетов: {result.discoverError}</div>}
          {result.discovered?.length > 0 && (
            <>
              <p className="text-muted">Банк вернул {result.discovered.length} счёт(ов) по этому токену. Добавьте нужные ниже, в разделе «Счета».</p>
            </>
          )}
          {result.discovered?.length === 0 && !result.discoverError && <p className="text-muted">Токен сохранён. Счетов банк пока не вернул.</p>}
        </div>
      )}
    </div>
  );
}

function AddAccountForm({ credentials, providers, onAdded }) {
  const [credentialId, setCredentialId] = useState('');
  const [name, setName] = useState('');
  const [accountId, setAccountId] = useState('');
  const [discovered, setDiscovered] = useState([]);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [discovering, setDiscovering] = useState(false);

  const discover = async (credId) => {
    setCredentialId(credId); setDiscovered([]); setAccountId(''); setError('');
    if (!credId) return;
    setDiscovering(true);
    try {
      const { data } = await api.post(`/finance/bank/credentials/${credId}/discover`);
      setDiscovered(data.discovered || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось получить список счетов по этому токену');
    } finally { setDiscovering(false); }
  };

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!name.trim() || !accountId) { setError('Укажите название и выберите счёт'); return; }
    setSaving(true);
    const cred = credentials.find(c => String(c.id) === String(credentialId));
    try {
      await api.post('/finance/bank/accounts', {
        name: name.trim(), provider: cred?.provider || 'tochka', provider_account_id: accountId, credential_id: credentialId
      });
      setName(''); setAccountId(''); setDiscovered([]); setCredentialId('');
      onAdded();
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка сохранения');
    } finally { setSaving(false); }
  };

  if (credentials.length === 0) return null;

  return (
    <form className="toolbar" onSubmit={submit}>
      <select value={credentialId} onChange={e => discover(e.target.value)}>
        <option value="">По какому токену искать счёт</option>
        {credentials.map(c => <option key={c.id} value={c.id}>{c.source_name || 'без юрлица'}{c.label ? ` (${c.label})` : ''}</option>)}
      </select>
      {discovering && <span className="text-muted">ищем счета...</span>}
      {discovered.length > 0 && (
        <select value={accountId} onChange={e => setAccountId(e.target.value)}>
          <option value="">Выберите счёт</option>
          {discovered.map(a => <option key={a.accountId} value={a.accountId}>{a.accountId}</option>)}
        </select>
      )}
      <input placeholder="Название счёта в системе" value={name} onChange={e => setName(e.target.value)} style={{ minWidth: 200 }} />
      <button type="submit" className="btn-primary btn-sm" disabled={saving || !accountId}>Добавить счёт</button>
      {error && <span className="error-msg">{error}</span>}
    </form>
  );
}

function RefreshToken({ account, onClose, onSaved }) {
 const [token,setToken]=useState('');const [error,setError]=useState('');const [busy,setBusy]=useState(false);
 return <div className="card mb-2"><h3>Обновить доступ: {account.name}</h3><p>Вставьте новый токен банка с доступом к выпискам этого счёта. Сам счёт и история операций сохранятся.</p><form onSubmit={async e=>{e.preventDefault();setBusy(true);setError('');try{await api.post(`/finance/bank/accounts/${account.id}/refresh-token`,{token});setToken('');onSaved();onClose();}catch(e){setError(e.response?.data?.error||'Не удалось обновить токен');}finally{setBusy(false);}}}><label>Новый токен<input type="password" autoComplete="off" required value={token} onChange={e=>setToken(e.target.value)}/></label>{error&&<div className="error-msg">{error}</div>}<button disabled={busy} className="btn-primary">Проверить и обновить</button> <button type="button" onClick={onClose}>Отмена</button></form></div>;
}

export default function Bank() {
  const { user } = useAuth();
  const [accounts, setAccounts] = useState([]);
  const [refreshAccount,setRefreshAccount]=useState(null);
  const [credentials, setCredentials] = useState([]);
  const [providers, setProviders] = useState([]);
  const [sources, setSources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState(null);

  const load = () => {
    setLoading(true);
    const calls = [api.get('/finance/bank/accounts'), api.get('/finance/bank/providers'), api.get('/finance/meta')];
    if (user.role === 'admin') calls.push(api.get('/finance/bank/credentials'));
    Promise.all(calls).then(([a, p, m, c]) => {
      setAccounts(a.data); setProviders(p.data); setSources(m.data.sources || []);
      if (c) setCredentials(c.data);
    }).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const sync = async () => {
    setSyncing(true); setSyncResult(null);
    try {
      const { data } = await api.post('/finance/bank/sync', {});
      setSyncResult(data.results);
    } finally { setSyncing(false); load(); }
  };

  const toggleActive = async (a) => {
    await api.patch(`/finance/bank/accounts/${a.id}`, { is_active: !a.is_active });
    load();
  };

  const removeAccount = async (a) => {
    if (!window.confirm(`Удалить счёт «${a.name}»?`)) return;
    const { data } = await api.delete(`/finance/bank/accounts/${a.id}`);
    if (data.deactivated) alert(data.reason);
    load();
  };

  const removeCredential = async (c) => {
    if (!window.confirm(`Удалить токен «${c.source_name || c.label || c.id}»? Счета, добавленные по нему, останутся, но перестанут синхронизироваться, пока не привяжете новый токен.`)) return;
    await api.delete(`/finance/bank/credentials/${c.id}`);
    load();
  };

  const providerLabel = (key) => providers.find(p => p.key === key)?.label || key;

  const exportAccounts = () => downloadExcel(
    'Банковские счета',
    ['Название', 'Юрлицо', 'Банк', 'ID в банке', 'Последняя синхронизация', 'Статус', 'Активен'],
    accounts.map(a => [
      a.name, a.source_name || '—', providerLabel(a.provider), a.provider_account_id || 'не привязан',
      a.last_synced_at ? new Date(a.last_synced_at).toLocaleString('ru') : '—',
      a.last_status === 'error' ? 'Ошибка' : a.last_status === 'ok' ? 'ОК' : '—',
      a.is_active ? 'Да' : 'Нет',
    ])
  );

  if (loading) return <div className="loading-text">Загрузка...</div>;

  return (
    <div>
      {refreshAccount&&<RefreshToken account={refreshAccount} onClose={()=>setRefreshAccount(null)} onSaved={load}/>}
      <p className="text-muted mb-2">
        Банковские счета компании. Токен вводится один раз и хранится в базе в зашифрованном виде —
        добавлять/удалять компании и счета можно самостоятельно, без участия разработчика.
      </p>

      {user.role === 'admin' && (
        <>
          <h3 className="mb-2">Компании и токены</h3>
          <CredentialForm sources={sources} providers={providers} onSaved={load} />
          {credentials.length > 0 && (
            <div className="table-wrap mb-2">
              <table>
                <thead><tr><th>Юрлицо</th><th>Банк</th><th>Метка</th><th>Счетов подключено</th><th>Добавлен</th><th></th></tr></thead>
                <tbody>
                  {credentials.map(c => (
                    <tr key={c.id}>
                      <td>{c.source_name || <span className="text-muted">не привязано</span>}</td>
                      <td>{providerLabel(c.provider)}</td>
                      <td>{c.label || '—'}</td>
                      <td>{c.accounts_count}</td>
                      <td>{new Date(c.created_at).toLocaleDateString('ru')}</td>
                      <td><button className="btn-danger btn-sm" onClick={() => removeCredential(c)}>Удалить</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <h3 className="mb-2">Добавить счёт по уже сохранённому токену</h3>
          <AddAccountForm credentials={credentials} providers={providers} onAdded={load} />
        </>
      )}

      <div className="toolbar" style={{ marginTop: 20 }}>
        <h3 style={{ margin: 0 }}>Счета</h3>
        <div className="toolbar-spacer" />
        {accounts.length > 0 && <button className="btn-secondary btn-sm" onClick={exportAccounts}>Экспорт в Excel</button>}
        <button className="btn-secondary btn-sm" onClick={sync} disabled={syncing}>{syncing ? 'Синхронизация...' : 'Синхронизировать сейчас'}</button>
      </div>

      {syncResult && (
        <div className="table-wrap mb-2">
          <table>
            <thead><tr><th>Счёт</th><th>Результат</th></tr></thead>
            <tbody>
              {syncResult.map((r, i) => (
                <tr key={i}>
                  <td>{r.name}</td>
                  <td>{r.ok ? `Импортировано: ${r.imported}, размечено автоматически: ${r.categorized}, повторов пропущено: ${r.duplicates}` : <span style={{ color: 'var(--danger)' }}>{r.error}</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {accounts.length === 0 ? (
        <div className="empty-state">Счета ещё не подключены</div>
      ) : (
        <div className="table-wrap">
          <table>
            <thead><tr><th>Название</th><th>Юрлицо</th><th>Банк</th><th>ID в банке</th><th>Последняя синхронизация</th><th>Статус</th><th>Активен</th>{user.role === 'admin' && <th></th>}</tr></thead>
            <tbody>
              {accounts.map(a => (
                <tr key={a.id}>
                  <td>{a.name}</td>
                  <td>{a.source_name || '—'}</td>
                  <td>{providerLabel(a.provider)}</td>
                  <td style={{ fontSize: 12 }}>{a.provider_account_id || <span className="text-muted">не привязан</span>}</td>
                  <td>{a.last_synced_at ? new Date(a.last_synced_at).toLocaleString('ru') : '—'}</td>
                  <td>{a.last_status === 'error' ? <span style={{ color: 'var(--danger)' }} title={a.last_error}>Ошибка</span> : a.last_status === 'ok' ? <span style={{ color: 'var(--success)' }}>ОК</span> : '—'}</td>
                  <td>
                    {user.role === 'admin'
                      ? <button className="btn-secondary btn-sm" onClick={() => toggleActive(a)}>{a.is_active ? 'Отключить' : 'Включить'}</button>
                      : (a.is_active ? 'Да' : 'Нет')}
                  </td>
                  {user.role === 'admin' && <td><button className="btn-secondary btn-sm" onClick={()=>setRefreshAccount(a)}>Обновить доступ</button> <button className="btn-danger btn-sm" onClick={() => removeAccount(a)}>Удалить</button></td>}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
